function updateAmazonReview() {
    const isMobile = window.matchMedia('(max-width: 580px)').matches;

    if (isMobile) {
        if ($('#new_product .product__title h1[rel="10404790010135"]').length) {

            if (!$('#new_product .amazon_button.fixed').length) {
                $('#new_product .amazon_button').clone().addClass('fixed').insertAfter('#new_product .amazon_button');
            }

            const $button = $('#new_product .amazon_button.fixed');
            const $review = $button.find('.amazon-review');

            if (!$review.length) {
                $button.prepend('<a href="https://www.amazon.com/Celladix-Chocolate-Charcoal-Salicylic-Color-Changing/dp/B0H1QRFF7L/ref=sr_1_7" class="amazonLink"><span class="amazon-review">⭐4.9 (14,685 reviews)</span></a>');
                $('#fd_frame').addClass('amazon');
            }

            $button.find('.amazon-review').css('background', '#00f5dd');
        } else if ($('#new_product .product__title h1[rel="10404606378263"]').length) {

            if (!$('#new_product .amazon_button.fixed').length) {
                $('#new_product .amazon_button').clone().addClass('fixed').insertAfter('#new_product .amazon_button');
            }

            const $button = $('#new_product .amazon_button.fixed');
            const $review = $button.find('.amazon-review');

            if (!$review.length) {
                $button.prepend('<a href="https://amazon.com/Celladix-Rebalancing-Clearing-Enlarged-Combination/dp/B0F8QDXWKV/ref=sr_1_1" class="amazonLink"><span class="amazon-review">⭐4.9 (14,685 reviews)</span></a>');
                $('#fd_frame').addClass('amazon');
            }

            $button.find('.amazon-review').css('background', '#ffff64');
        }
    } else {
        // 데스크탑으로 전환되면 모바일 전용 fixed 버튼 정리
        $('#new_product .amazon_button.fixed').remove();
    }

    const imgUrl = 'https://cdn.shopify.com/s/files/1/0766/4045/2887/files/02-1._Mint_Chocolate_BHA_Charcoal_Cleanser_Sub_Thumb_1.jpg?v=1784167910';

    if (!isMobile) {
        if ($('#new_product .product__title h1[rel="10404790010135"]').length) {
            $('#new_product .product__media-wrapper .swiper-wrapper li:first-child .product__media img').attr({
                src: imgUrl,
                'data-src': imgUrl,
                srcset: imgUrl,
                'data-srcset': imgUrl
            });
        }
    }
}

updateAmazonReview();

// resize 대신 matchMedia change 이벤트 사용 (580px 경계를 넘을 때만 실행)
const mobileMediaQuery = window.matchMedia('(max-width: 580px)');
if (mobileMediaQuery.addEventListener) {
    mobileMediaQuery.addEventListener('change', updateAmazonReview);
} else {
    // 구형 Safari 등 폴백
    mobileMediaQuery.addListener(updateAmazonReview);
}


if ($('#new_product .product__title h1[rel="10404790010135"], #new_product .product__title h1[rel="10404606378263"]').length) {

    var TIMEZONE = 'America/New_York'; // 필요시 America/Chicago, America/Denver, America/Los_Angeles 로 변경

    // 지정한 타임존의 "현재 시각"을 Date 객체로 반환
    function getZonedNow(timeZone) {
        var now = new Date();
        var zonedStr = now.toLocaleString('en-US', { timeZone: timeZone });
        return new Date(zonedStr);
    }

    // 지정한 타임존 기준으로 남은 시간(ms) 계산
    function getRemainMs(timeZone) {
        var zonedNow = getZonedNow(timeZone);
        var midnight = new Date(zonedNow);
        midnight.setHours(24, 0, 0, 0);
        return midnight - zonedNow;
    }

    // 1) HTML을 만들기 전에 먼저 값부터 계산
    var remainMs = getRemainMs(TIMEZONE);

    var totalDaySec = 24 * 60 * 60;
    var elapsedSec = totalDaySec - Math.floor(remainMs / 1000);
    var ratio = elapsedSec / totalDaySec;
    var remainRatio = 1 - ratio;

    var hours = Math.floor(remainMs / (1000 * 60 * 60));
    var minutes = Math.floor((remainMs % (1000 * 60 * 60)) / (1000 * 60));
    var seconds = Math.floor((remainMs % (1000 * 60)) / 1000);

    var count = Math.ceil(50 - (49 * ratio));
    if (count < 1) count = 1;
    if (count > 50) count = 50;

    // 2) 계산된 값을 style에 바로 박아서 마크업 생성
    $('#new_product .product__media-wrapper').prepend(
        '<div class="timeBanner">' +
            '<div class="timeBanner__bg"></div>' +
            '<div class="timeBanner__bar" style="width:' + (remainRatio * 100) + '%;"></div>' +
            '<p class="timeBanner__text">⏰Time remaining (' +
                '<span class="hour">' + String(hours).padStart(2, '0') + '</span>:' +
                '<span class="minute">' + String(minutes).padStart(2, '0') + '</span>:' +
                '<span class="sec">' + String(seconds).padStart(2, '0') + '</span>' +
                ') | Only  <span class="count">' + count + '</span>Left</p>' +
            '<p class="timeBanner__sub">Price reverts once stock runs out.</p>' +
        '</div>'
    );

    if ($('#new_product .product__title h1[rel="10404606378263"]').length){
        $('#new_product .timeBanner__bar').css('background', '#f3ef13ff');
    }

    var $bar = $('#new_product .timeBanner__bar');

    // 3) 매초 갱신
    function updateTimer() {
        var remainMs = getRemainMs(TIMEZONE);

        var hours = Math.floor(remainMs / (1000 * 60 * 60));
        var minutes = Math.floor((remainMs % (1000 * 60 * 60)) / (1000 * 60));
        var seconds = Math.floor((remainMs % (1000 * 60)) / 1000);

        $('#new_product .timeBanner .hour').text(String(hours).padStart(2, '0'));
        $('#new_product .timeBanner .minute').text(String(minutes).padStart(2, '0'));
        $('#new_product .timeBanner .sec').text(String(seconds).padStart(2, '0'));

        var totalDaySec = 24 * 60 * 60;
        var elapsedSec = totalDaySec - Math.floor(remainMs / 1000);
        var ratio = elapsedSec / totalDaySec;

        var count = Math.ceil(50 - (49 * ratio));
        if (count < 1) count = 1;
        if (count > 50) count = 50;

        $('#new_product .timeBanner .count').text(count);

        var remainRatio = 1 - ratio;
        $bar.css('width', (remainRatio * 100) + '%');
    }

    setInterval(updateTimer, 1000);
}